import React, { useMemo } from 'react'

import { ProTable } from '@tidbcloud/uikit/biz'
import { MRT_SortingState } from '@tidbcloud/uikit/biz'

import { StatementModel } from '../../utils/type'
import { useStatementColumns } from './columns'

interface ListTableProps<T> {
  data: T[]
  sortBy?: MRT_SortingState
  onPlanClick: (planDigest: string) => void
}

// TODO: extract to reuse
export const ListTable: React.FC<
  React.PropsWithChildren<ListTableProps<StatementModel>>
> = ({ data, sortBy = [], onPlanClick }) => {
  const columns = useStatementColumns(onPlanClick)

  const sortedData = useMemo(() => {
    if (!data || !sortBy[0]) {
      return data
    }
    const [{ id, desc }] = sortBy
    const sorted = [...data]
    sorted.sort((a, b) => {
      const aVal = a[id as keyof StatementModel] ?? 0
      const bVal = b[id as keyof StatementModel] ?? 0
      if (desc) {
        return aVal > bVal ? -1 : 1
      } else {
        return aVal > bVal ? 1 : -1
      }
    })
    return sorted
  }, [data, sortBy])

  return (
    <ProTable<StatementModel>
      // stickyHeader
      // sortable
      columns={columns}
      data={sortedData}
      state={{ sorting: sortBy }}
      // highlightOnHover={true}
      enableColumnPinning
      initialState={{ columnPinning: { right: ['action'] } }}
    />
  )
}
